import React, { useEffect, useState, useCallback } from "react";
import ComboAbmArtArticulos from "../../Combos/ComboAbmArtArticulos"
import ComboAbmArtPresentaciones from "../../Combos/ComboAbmArtPresentaciones"
import ComboAbmArtTamanos from "../../Combos/ComboAbmArtTamanos"
import ComboAbmArtUnidadesMedida from "../../Combos/ComboAbmArtUnidadesMedida"
import { NumberBox } from "devextreme-react";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";

function LV_ART_Articulos_SelectorConGrid_Selector({ idEEX, esCompras, esVentas, codigoListaPrecios,
  tieneEnCuentaLPdelCliente, codigoMonedaEnviadaPorDocumento, actualizarObjetoParaAgregar,
  tienePresentaciones = false, tieneTamanos = false, tieneUnidadesMedida = false,
  onClickAgregar, muestraComponentesDelTotal = true,
  Comprables = false, Vendibles = false, Fabricables = false, Stockeables = false, Servicios = false,
  ExcluirVendibles = false, ExcluirComprables = false, ExcluirFabricables = false, ExcluirStockeables = false, ExcluirServicios = false,
  PermiteVisualizarStock = true, CodigoTipoDoc, PuedeModificarPrecios = true }) {

  const [codigoArticulo, setCodigoArticulo] = useState("");
  const [articulo, setArticulo] = useState("");
  const [codigoTamano, setCodigoTamano] = useState("");
  const [tamano, setTamano] = useState("");
  const [reloadTamanos, setReloadTamanos] = useState(false);
  const [codigoPresentacion, setCodigoPresentacion] = useState("");
  const [presentacion, setPresentacion] = useState("");
  const [reloadPresentaciones, setReloadPresentaciones] = useState(false);
  const [codigoUnidadMedida, setCodigoUnidadMedida] = useState("");
  const [unidadMedida, setUnidadMedida] = useState("");
  const [reloadUnidadesMedida, setReloadUnidadesMedida] = useState(false);
  const [cantidad, setCantidad] = useState(1);
  const [porcentajeIVA, setPorcentajeIVA] = useState(21);
  const [porcentajeImpuestosInternos, setPorcentajeImpuestosInternos] = useState(0);
  const [importeNeto, setImporteNeto] = useState(0);
  const [importeBonificaciones, setImporteBonificaciones] = useState(0);
  const [importeRecargos, setImporteRecargos] = useState(0);
  const [importeSubTotal, setImporteSubTotal] = useState(0);
  const [importeIVA, setImporteIVA] = useState(0);
  const [importeImpuestosInternos, setImporteImpuestosInternos] = useState(0);
  const [importeTotal, setImporteTotal] = useState(0);
  const [conDescuentosRecargosActivos, setConDescuentosRecargosActivos] = useState(true);
  const { ABM_ART_Articulos: { function_ABM_ART_Articulos_LeerPrecio,
    function_ABM_ART_Articulos_LeerStockCompania } } = require('neftis7_apicaller');

  const [stockReal, setStockReal] = useState(0);
  const [stockComprometido, setStockComprometido] = useState(0);

  const objetoParaAgregar = {
    CodigoArticulo: codigoArticulo,
    CodigoCompania: localStorage.getItem("CodigoCompania"),
    CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
    CodigoPlanta: localStorage.getItem("CodigoPlanta"),
    Articulo: articulo,
    Observaciones: articulo,
    CodigoPresentacion: codigoPresentacion,
    Presentacion: presentacion,
    CodigoTamano: codigoTamano,
    Tamano: tamano,
    CodigoUnidadMedida: codigoUnidadMedida,
    UnidadMedida: unidadMedida,
    Cantidad: cantidad,
    ImporteNeto: importeNeto,
    ImporteNetoTotal: importeNeto * cantidad,
    ImporteBonificaciones: importeBonificaciones,
    ImporteBonificacionesTotal: importeBonificaciones * cantidad,
    ImporteDescuentos: importeBonificaciones,
    ImporteDescuentosTotal: importeBonificaciones * cantidad,
    ImporteRecargos: importeRecargos,
    ImporteRecargosTotal: importeRecargos * cantidad,
    ImporteSubTotal: importeSubTotal,
    ImporteSubTotalTotal: importeSubTotal * cantidad,
    ImporteIVA: importeIVA,
    ImporteIVATotal: importeIVA * cantidad,
    ImporteImpuestosInternos: importeImpuestosInternos,
    ImporteImpuestosInternosTotal: importeImpuestosInternos * cantidad,
    ImporteTotal: importeTotal,
    ImporteTotalTotal: importeTotal * cantidad,
    IdItemCotizacion: 0,
    IdItemPedido: 0,
    IdItemRemito: 0,
    PorcentajeImpuestosInternos: porcentajeImpuestosInternos,
    PorcentajeIVA: porcentajeIVA
  }

  const handleCodigoArticuloOnValueChanged = useCallback(({ component }) => {
    if (component && component != null && component.option != null) {
      const selectedItem = component.option('selectedItem');
      setCodigoArticulo(selectedItem.CodigoArticulo)
      setArticulo(selectedItem.Descripcion)
    } else {
      setCodigoArticulo("")
      setArticulo("")
    }
  }, []);

  const handleCodigoPresentacionOnValueChanged = useCallback(({ component }) => {
    if (component && component.option && typeof component.option === 'function') {
      const selectedItem = component.option('selectedItem');
      if (selectedItem && selectedItem.CodigoPresentacion) {
        setCodigoPresentacion(selectedItem.CodigoPresentacion)
        setPresentacion(selectedItem.Descripcion)
      } else {
        setCodigoPresentacion("")
        setPresentacion("")
      }
    }
  }, []);

  const handleCodigoTamanoOnValueChanged = useCallback(({ component }) => {
    if (component && component.option && typeof component.option === 'function') {
      const selectedItem = component.option('selectedItem');
      if (selectedItem && selectedItem.CodigoTamano) {
        setCodigoTamano(selectedItem.CodigoTamano)
        setTamano(selectedItem.Descripcion)
      } else {
        setCodigoTamano("")
        setTamano("")
      }
    }
  }, []);

  const handleCodigoUnidadMedidaOnValueChanged = useCallback(({ component }) => {
    if (component && component.option && typeof component.option === 'function') {
      const selectedItem = component.option('selectedItem');
      if (selectedItem && selectedItem.CodigoUnidadMedida) {
        setCodigoUnidadMedida(selectedItem.CodigoUnidadMedida)
        setUnidadMedida(selectedItem.Descripcion)
      } else {
        setCodigoUnidadMedida("")
        setUnidadMedida("")
      }
    }
  }, []);

  const handleCantidadOnValueChanged = (e) => {
    setCantidad(e.value)
  }

  const handleImporteNetoOnValueChanged = (e) => {
    setImporteNeto(e.value)
  }

  const handleImporteIVAOnValueChanged = (e) => {
    setImporteIVA(e.value)
  }

  const handleImporteBonificacionesOnValueChanged = (e) => {
    setImporteBonificaciones(e.value)
  }

  const handleImporteRecargosOnValueChanged = (e) => {
    setImporteRecargos(e.value)
  }

  const handleImporteSubTotalOnValueChanged = (e) => {
    setImporteSubTotal(e.value)
  }

  const handleImporteImpuestosInternosOnValueChanged = (e) => {
    setImporteImpuestosInternos(e.value)
  }

  const handleImporteTotalOnValueChanged = (e) => {
    setImporteTotal(e.value)
  }

  const resolucionDePrecioYStock = async () => {
    if (codigoArticulo !== "" && codigoArticulo != null && codigoArticulo != undefined &&
      codigoPresentacion !== "" && codigoPresentacion != null && codigoPresentacion != undefined &&
      codigoTamano !== "" && codigoTamano != null && codigoTamano != undefined &&
      codigoUnidadMedida !== "" && codigoUnidadMedida != null && codigoUnidadMedida != undefined) {

      const resultPrecio = await function_ABM_ART_Articulos_LeerPrecio(codigoArticulo, codigoPresentacion,
        codigoTamano, codigoUnidadMedida, idEEX, esCompras, esVentas, codigoListaPrecios,
        tieneEnCuentaLPdelCliente, codigoMonedaEnviadaPorDocumento)

      setImporteNeto(resultPrecio.data.ImporteNeto)
      setImporteBonificaciones(resultPrecio.data.ImporteBonificacion)
      setImporteRecargos(resultPrecio.data.ImporteRecargo)
      setImporteImpuestosInternos(resultPrecio.data.ImporteImpuestosInternos)
      setPorcentajeImpuestosInternos(resultPrecio.data.PorcentajeImpuestosInternos)

      setPorcentajeIVA(resultPrecio.data.PorcentajeIVA)
      const tiposDocSinIVA = [41, 42, 43, 71, 72, 73];
      if (tiposDocSinIVA.includes(CodigoTipoDoc)) {
        setPorcentajeIVA(0)
      }

      const resultStock = await function_ABM_ART_Articulos_LeerStockCompania(codigoArticulo, codigoPresentacion,
        codigoTamano, codigoUnidadMedida)

      setStockReal(resultStock.data.CantidadActual)
      setStockComprometido(resultStock.data.CantidadDisponible)

    }
  }

  useEffect(() => {
    const subtotal = importeNeto - importeBonificaciones + importeRecargos;
    setImporteSubTotal(subtotal);
    const iVA = subtotal !== 0 && porcentajeIVA !== 0 ? (subtotal * porcentajeIVA / 100) : 0;
    setImporteIVA(iVA)
    const impuestosInternos = subtotal !== 0 && porcentajeImpuestosInternos !== 0 ? (subtotal * porcentajeImpuestosInternos / 100) : 0;
    setImporteImpuestosInternos(impuestosInternos)
    const total = subtotal + importeIVA + importeImpuestosInternos;
    setImporteTotal(total);
  }, [importeNeto, importeBonificaciones, importeRecargos, importeIVA, importeImpuestosInternos]);

  useEffect(() => {
    resolucionDePrecioYStock();
  }, [codigoArticulo, codigoUnidadMedida, codigoPresentacion, codigoTamano]);

  useEffect(() => {
    if (localStorage.getItem("CodigoCompania") == "SAL" || localStorage.getItem("CodigoCompania") == "SAI"){
      setConDescuentosRecargosActivos(false)
    }
    setCantidad(1)
    setPorcentajeIVA(21);
    setPorcentajeImpuestosInternos(0);
    setImporteNeto(0);
    setImporteBonificaciones(0);
    setImporteRecargos(0);
    setImporteSubTotal(0);
    setImporteIVA(0);
    setImporteImpuestosInternos(0);
    setImporteTotal(0);

    setStockReal(0);
    setStockComprometido(0);

    setReloadPresentaciones(true)
    setReloadTamanos(true)
    setReloadUnidadesMedida(true)

  }, [codigoArticulo]);

  useEffect(() => {
    if (objetoParaAgregar) {
      actualizarObjetoParaAgregar(objetoParaAgregar);
    }
  }, [objetoParaAgregar]);

  return (
    <div className="LV-GroupBox-div LV-FlexContainer">
      <table style={{ width: '100%' }} >
        <tbody>
          <tr>
            <td style={{ margin: '10px', padding: '5px' }}>
              <table style={{ width: '100%' }} >
                <tbody>
                  <tr>
                    <td style={{ margin: '10px', padding: '5px', width: '80%' }}>
                      <ComboAbmArtArticulos
                        DescripcionCompleta={true}
                        value={codigoArticulo}
                        onValueChanged={handleCodigoArticuloOnValueChanged}
                        CampoDescripcion="CodigoDescripcion"
                        Comprables={Comprables}
                        Vendibles={Vendibles}
                        Fabricables={Fabricables}
                        Stockeables={Stockeables}
                        Servicios={Servicios}
                        ExcluirVendibles={ExcluirVendibles}
                        ExcluirComprables={ExcluirComprables}
                        ExcluirFabricables={ExcluirFabricables}
                        ExcluirStockeables={ExcluirStockeables}
                        ExcluirServicios={ExcluirServicios} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px' }}>
                      <NumberBox
                        label="Cantidad"
                        value={cantidad}
                        onValueChanged={handleCantidadOnValueChanged} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td style={{ margin: '10px', padding: '5px' }} >
              <table width={'100%'} >
                <tbody>
                  <tr>
                    <td style={{ margin: '10px', padding: '5px', width: '26%' }} >
                      <ComboAbmArtPresentaciones
                        value={codigoPresentacion}
                        CodigoArticulo={codigoArticulo}
                        onValueChanged={handleCodigoPresentacionOnValueChanged}
                        reloadData={reloadPresentaciones}
                        visible={tienePresentaciones} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '26%' }}>
                      <ComboAbmArtTamanos
                        value={codigoTamano}
                        CodigoArticulo={codigoArticulo}
                        onValueChanged={handleCodigoTamanoOnValueChanged}
                        reloadData={reloadTamanos}
                        visible={tieneTamanos} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '26%' }}>
                      <ComboAbmArtUnidadesMedida
                        value={codigoUnidadMedida}
                        CodigoArticulo={codigoArticulo}
                        onValueChanged={handleCodigoUnidadMedidaOnValueChanged}
                        reloadData={reloadUnidadesMedida}
                        EsCompras={esCompras}
                        EsVentas={esVentas}
                        visible={tieneUnidadesMedida} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '11%' }}>
                      <NumberBox
                        format="#,##0.##"
                        tabIndex={-1}
                        label="S.Real"
                        value={stockReal}
                        readOnly={true}
                        visible={PermiteVisualizarStock} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '11%' }}>
                      <NumberBox
                        format="#,##0.##"
                        tabIndex={-1}
                        label="S.Comp."
                        value={stockComprometido}
                        readOnly={true}
                        visible={PermiteVisualizarStock} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td style={{ margin: '10px', padding: '5px' }} >
              <table width={'100%'} >
                <tbody>
                  <tr>
                    <td style={{ margin: '10px', padding: '5px', width: '13%' }}>
                      <NumberBox
                        format="$ #,##0.##"
                        label="Neto"
                        value={importeNeto}
                        onValueChanged={handleImporteNetoOnValueChanged}
                        visible={muestraComponentesDelTotal}
                        readOnly={!PuedeModificarPrecios} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '13%' }}>
                      <NumberBox
                        format="$ #,##0.##"
                        label="Bonificación"
                        value={importeBonificaciones}
                        onValueChanged={handleImporteBonificacionesOnValueChanged}
                        visible={conDescuentosRecargosActivos} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '13%' }}>
                      <NumberBox
                        format="$ #,##0.##"
                        label="Recargo"
                        value={importeRecargos}
                        onValueChanged={handleImporteRecargosOnValueChanged}
                        visible={conDescuentosRecargosActivos} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '13%' }}>
                      <NumberBox
                        format="$ #,##0.##"
                        tabIndex={-1}
                        label="SubTotal"
                        value={importeSubTotal}
                        onValueChanged={handleImporteSubTotalOnValueChanged}
                        visible={muestraComponentesDelTotal}
                        readOnly={true} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '13%' }}>
                      <NumberBox
                        format="$ #,##0.##"
                        tabIndex={-1}
                        label="I.V.A."
                        value={importeIVA}
                        onValueChanged={handleImporteIVAOnValueChanged}
                        visible={muestraComponentesDelTotal}
                        readOnly={true} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '13%' }}>
                      <NumberBox
                        format="$ #,##0.##"
                        tabIndex={-1}
                        label="Imp.Int."
                        value={importeImpuestosInternos}
                        onValueChanged={handleImporteImpuestosInternosOnValueChanged}
                        visible={muestraComponentesDelTotal}
                        readOnly={true} />
                    </td>
                    <td style={{ margin: '10px', padding: '5px', width: '22%' }}>
                      <NumberBox
                        label="Total"
                        tabIndex={-1}
                        format="$ #,##0.##"
                        value={importeTotal}
                        onValueChanged={handleImporteTotalOnValueChanged}
                        readOnly={true} />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

        </tbody>
      </table>

      <LVButtonAccion onClick={onClickAgregar} Texto="AGREGAR" height={136} Ancho={136} />

    </div>
  );
}

export default LV_ART_Articulos_SelectorConGrid_Selector

